import type { ParsedUrlQuery } from 'querystring';

import { parseDateRangeType, parseHideDelivered, parseKeyword } from 'Components/Account/AccountPage.helpers';
import { AccountDateRange } from 'Types/account';
import { PurchasesCompleteStatusTypes } from 'Types/purchaseCompleteStatus';
import { getAccountDateRange } from 'Utilities/helpers/getAccountDateRange';
import type { AccountStatusCountsParams } from 'Utilities/hooks/account/useAccountBiddingStatusCounts';

export const getCountEndpointParams = (query: ParsedUrlQuery): AccountStatusCountsParams => {
	const { from, to } = getAccountDateRange(parseDateRangeType(query, AccountDateRange.ALL));
	return {
		fromSoldDate: from,
		hideDeliveredEnquiries: parseHideDelivered(query),
		keyword: parseKeyword(query),
		toSoldDate: to,
	};
};

export const isActive = (
	chipStatus: PurchasesCompleteStatusTypes,
	currentStatus?: PurchasesCompleteStatusTypes,
): boolean => chipStatus === currentStatus || (!currentStatus && chipStatus === PurchasesCompleteStatusTypes.All);
